import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessTimeFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"access_time_filled"}/>
}
